// extracted by mini-css-extract-plugin
export default {"centeredGrayedText":"markets__centeredGrayedText__NXR4pC"};